module.exports = __webpack_public_path__ + "static/media/5-10.704ecd3f.mp3";